import { createLoggers } from '@highlight-cp/logger';

export const { error, warn, debug, info } = createLoggers({ tag: 'highlighter-app' });
